const GLORY_WISHLIST_KEY = 'glory:wishlist';

function gloryWishlistRead() {
  try {
    const raw = localStorage.getItem(GLORY_WISHLIST_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.map(String) : [];
  } catch (e) {
    return [];
  }
}

function gloryWishlistWrite(list) {
  try {
    localStorage.setItem(GLORY_WISHLIST_KEY, JSON.stringify(list));
  } catch (e) {
    /* storage unavailable (private mode / quota) — fail silently */
  }
}

class GloryWishlist extends HTMLElement {
  connectedCallback() {
    this.productId = String(this.dataset.productId || '');
    if (!this.hasAttribute('role')) this.setAttribute('role', 'button');
    if (!this.hasAttribute('tabindex')) this.setAttribute('tabindex', '0');

    this.onClick = this.onClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.syncState = this.syncState.bind(this);

    this.addEventListener('click', this.onClick);
    this.addEventListener('keydown', this.onKeydown);
    document.addEventListener('glory:wishlist:change', this.syncState);

    this.syncState();
  }

  disconnectedCallback() {
    document.removeEventListener('glory:wishlist:change', this.syncState);
  }

  isActive() {
    return gloryWishlistRead().includes(this.productId);
  }

  syncState() {
    const active = this.isActive();
    this.classList.toggle('is-active', active);
    this.setAttribute('aria-pressed', active ? 'true' : 'false');
  }

  toggle() {
    if (!this.productId) return;
    let list = gloryWishlistRead();
    if (list.includes(this.productId)) {
      list = list.filter((id) => id !== this.productId);
    } else {
      list.push(this.productId);
    }
    gloryWishlistWrite(list);
    document.dispatchEvent(new CustomEvent('glory:wishlist:change'));
  }

  onClick(event) {
    event.preventDefault();
    event.stopPropagation();
    this.toggle();
  }

  onKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
      event.preventDefault();
      event.stopPropagation();
      this.toggle();
    }
  }
}

if (!customElements.get('glory-wishlist')) {
  customElements.define('glory-wishlist', GloryWishlist);
}
